let questions = document.querySelectorAll(".questions");

questions.forEach(questions => {
  questions.addEventListener("click", event => {

    const active = document.querySelector(".questions.active");

    if (active && active !== questions) {
      active.classList.toggle("active");
      active.nextElementSibling.style.maxHeight = 0;
    }

    questions.classList.toggle("active");

    const answers = questions.nextElementSibling;

    if (questions.classList.contains("active")) {
      answers.style.maxHeight = (answers.scrollHeight + 20) + "px";
    } else {
      answers.style.maxHeight = 0;
    }

  });
});